import { createBrowserHistory } from 'history'
/**
 * @type {import("history").History<any>}
 */
const history = createBrowserHistory({});
export default history
